var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFactCounter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.428 20.691C20.7536 20.691 25.0709 16.3737 25.0709 11.0481C25.0709 5.72253 20.7536 1.40527 15.428 1.40527C10.1024 1.40527 5.78516 5.72253 5.78516 11.0481C5.78516 16.3737 10.1024 20.691 15.428 20.691Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4273 15.3336C17.7943 15.3336 19.713 13.4149 19.713 11.0479C19.713 8.68099 17.7943 6.76221 15.4273 6.76221C13.0604 6.76221 11.1416 8.68099 11.1416 11.0479C11.1416 13.4149 13.0604 15.3336 15.4273 15.3336Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5633 20.5194L11.6776 28.448C11.6403 28.5987 11.5713 28.7397 11.4752 28.8616C11.3792 28.9835 11.2582 29.0836 11.1205 29.1551C10.9751 29.2182 10.8183 29.2508 10.6598 29.2508C10.5012 29.2508 10.3444 29.2182 10.199 29.1551L3.08475 26.048C2.93552 25.9774 2.80422 25.874 2.70069 25.7455C2.59715 25.6169 2.52409 25.4666 2.48697 25.3057C2.44986 25.1449 2.44965 24.9777 2.48638 24.8168C2.52311 24.6559 2.59582 24.5054 2.69904 24.3766L8.20618 17.4766",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8486 20.4122L19.7772 28.4479C19.8156 28.6011 19.8873 28.744 19.9873 28.8662C20.0874 28.9885 20.2132 29.0871 20.3558 29.155C20.4972 29.2189 20.6506 29.252 20.8058 29.252C20.961 29.252 21.1144 29.2189 21.2558 29.155L28.3272 26.0479C28.4787 25.9782 28.6118 25.8741 28.716 25.7439C28.8201 25.6137 28.8925 25.461 28.9272 25.2979C28.9678 25.1384 28.9696 24.9714 28.9323 24.8111C28.895 24.6508 28.8198 24.5017 28.7129 24.3765L22.9701 17.0693",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.706055 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactCounter1);
export default __webpack_public_path__ + "static/media/icon-fact-counter-1.28a6030d54e6d2dc5814c0a805992a53.svg";
export { ForwardRef as ReactComponent };